import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class FieldPageService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.FIELD_PAGE = '/api/field-page';
    
        this.GET_BY_ID = '/{id}';
        this.GET_BY_TABLE = '/tableType/{tableType}/tableId/{tableId}';
        this.CREATE_BY_TABLE = '/tableType/{tableType}/tableId/{tableId}/project/{projectId}';

    }

    async getFieldPageById(id) {
        try {
            let url = window.location.origin + this.FIELD_PAGE + this.GET_BY_ID;
            url = url
                .replace('{id}', id)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getFieldPageListByTable(tableType, tableId) {
        try {
            let url = window.location.origin + this.FIELD_PAGE + this.GET_BY_TABLE;
            url = url
                .replace('{tableType}', tableType)
                .replace('{tableId}', tableId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async createFieldPageListByTable(tableType, tableId, projectId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.FIELD_PAGE + this.CREATE_BY_TABLE;
        url = url
            .replace('{tableType}', tableType)
            .replace('{tableId}', tableId)
            .replace('{projectId}', projectId)
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify({})
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async createFieldPage(fieldPage) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.FIELD_PAGE;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(fieldPage)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateFieldPage(fieldPage) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.FIELD_PAGE;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(fieldPage)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteFieldPage(deleteFieldPageMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.FIELD_PAGE;
        try{
            return this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(deleteFieldPageMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default FieldPageService;
